import { render, staticRenderFns } from "./BaseFileDropZone.vue?vue&type=template&id=5b378816&scoped=true"
import script from "./BaseFileDropZone.vue?vue&type=script&lang=js"
export * from "./BaseFileDropZone.vue?vue&type=script&lang=js"
import style0 from "./BaseFileDropZone.vue?vue&type=style&index=0&id=5b378816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b378816",
  null
  
)

export default component.exports